import { ComponentMyTools } from "src/Components/Pumkin/MyTools";

export const PageMyTools = () => {
    return <ComponentMyTools />;
};
